import React from 'react';
import nameProfileActive from '../../../../../external/backPages/img/images/name-profile-active.svg';
import nameProfileInactive from '../../../../../external/backPages/img/images/name-profile-inactive.svg';
import emailActive from '../../../../../external/backPages/img/images/email-active.svg';
import emailInactive from '../../../../../external/backPages/img/images/email-inactive.svg';
import phoneActive from '../../../../../external/backPages/img/images/phone-active.svg';
import phoneInactive from '../../../../../external/backPages/img/images/phone-inactive.svg';

import { HOSTNAME } from "../../../../Urls";
import { get, getCancelToken, post } from "../../../../../intelws_portal/utils/backendInterface";
import { AxiosResponse } from 'axios';
import Badge from '../../../../../intelws_portal/constructs/elements/Badge';
import Button from '../../../../../intelws_portal/constructs/elements/Button';
import ModalInputText from '../../../../../intelws_portal/constructs/modal/ModalInputText';


interface IFetchUserInfoRepr extends AxiosResponse {
    data: {
        name: string,
        email: string,
        phone_num: string,
        is_phone_num_edit: boolean,
    }
}

export interface IClientCardProps {
    userId: number,
    clientContext: boolean,
    InvoiceCard?: boolean,
    bottomBorder?: boolean
    isLead?: boolean,
}

function ClientCard(props: IClientCardProps) {
    const ENDPOINT = "api/clientdashboard/";
    const [name, setName] = React.useState("");
    const [email, setEmail] = React.useState("");
    const [phoneNum, setPhoneNum] = React.useState("");
    const [phoneLength, setPhoneLength] = React.useState(0);
    const [isPhoneNumEdit, setIsPhoneNumEdit] = React.useState(false);
    const [isPhoneNumInEditMode, setIsPhoneNumInEditMode] = React.useState(false);

    const cancelTokenSource = React.useRef(getCancelToken());

    React.useEffect(() => {
        let queryParams = {
            user_id: -1,
            section: "client_info"
        }
        if (!Number.isNaN(props.userId)) {
            queryParams.user_id = props.userId;
        }
        const requestResponse = get(ENDPOINT, cancelTokenSource.current.token, queryParams) as Promise<IFetchUserInfoRepr>;
        requestResponse.then((response) => {
            setName(response.data.name);
            setEmail(response.data.email);
            setPhoneNum(response.data.phone_num);
            setPhoneLength(response.data.phone_num.length);
            setIsPhoneNumEdit(response.data.is_phone_num_edit);
        })
        return () => {
            cancelTokenSource.current.cancel();
        }
    }, [])

    function getNameContent() {
        if (props.isLead == undefined || !props.isLead) {
            return name;
        }

        return <>

            {name}
            <Badge badgeType="info" value="Lead" />
        </>
    }

    function getPhoneNumContent() {
        function isValidUSPhoneNumber(phone: string): boolean {
            const regex = /^\d{3}-\d{3}-\d{4}$/;
            return regex.test(phone);
        }
        
        function saveNewPhoneNumber() {
            let queryParams = {
                user_id: -1,
                section: "edit_phone_number"
            }
            if (!Number.isNaN(props.userId)) {
                queryParams.user_id = props.userId;
            }
            const formData = new FormData();
            formData.append("new_phone_num", phoneNum);
            const requestResponse = post(ENDPOINT, formData, cancelTokenSource.current.token, queryParams);
            requestResponse.then(() => {
                setIsPhoneNumInEditMode(false);
            })
        }

        if (!isPhoneNumEdit) {
            return (
                <div className="col-md-4 col-sm-6 col-xs-12">
                    <p><img src={phoneActive} className="active" alt="" /> &nbsp;&nbsp;&nbsp;
                        <a href={`tel:${phoneNum}`} style={{ color: "black" }}>{phoneNum}</a></p>
                </div>
            )
        } else {
            return (
                <div className="col-md-4 col-sm-6 col-xs-12">
                    <p><img src={phoneActive} className="active" alt="" /> &nbsp;&nbsp;&nbsp;
                    {(() => {
                        if (!isPhoneNumInEditMode) {
                            return (
                                <>
                                    <a href={`tel:${phoneNum}`} style={{ color: "black" }}>{phoneNum}</a>
                                    <Button buttonValue={{icon: "Edit"}} onClick={() => setIsPhoneNumInEditMode(true)} />
                                </>
                            )
                        }
                        return (
                            <>
                                <ModalInputText title={"Phone Number"} value={phoneNum} onChange={(e) => {
                                    setPhoneLength(phoneNum.length)
                                    if (e.target.value.length <= 12) {
                                        if ((phoneNum.length == 3 || phoneNum.length == 7) && phoneLength < phoneNum.length) {
                                            setPhoneLength(phoneNum.length)
                                            setPhoneNum(phoneNum + "-" + e.target.value[e.target.value.length - 1])
                                        } else {
                                            setPhoneNum(e.target.value);
                                        }
                                    }
                                }}  />
                                <Button buttonValue={{icon: "Save"}} active={isValidUSPhoneNumber(phoneNum)} onClick={saveNewPhoneNumber} />
                            </>
                        )
                    })()}
                    </p>
                </div>
            )
        }
    }

    function getCardHeader() {
        if (!props.clientContext) {
            if (props.bottomBorder) {
                return (
                    <div className="contact-detail" style={{ textAlign: "center", borderBottom: "1px solid #dee2e6" }}>
                        {(props.isLead != undefined && props.isLead) 
                            ? <div className="col-md-4 col-sm-6 col-xs-12">
                                <p style={{ color: "black" }}> <img src={nameProfileActive} className="active" alt="" /> &nbsp;&nbsp;&nbsp;
                                    Lead
                                </p>
                            </div> 
                            : null
                        }
                        <div className="col-md-4 col-sm-6 col-xs-12">
                            <p style={{ color: "black" }}> <img src={nameProfileActive} className="active" alt="" /> &nbsp;&nbsp;&nbsp;
                                {getNameContent()}
                            </p>
                        </div>
                        <div className="col-md-4 col-sm-6 col-xs-12">
                            <p> <img src={emailActive} className="active" alt="" /> &nbsp;&nbsp;&nbsp;
                                <a href={`mailto:${email}`} style={{ color: "black" }}>{email}</a></p>
                        </div>
                        {getPhoneNumContent()}
                        
                    </div>
                )
            }
            else {
                return (
                    <div className="contact-detail" style={{ textAlign: "center" }}>
                        <div className="col-md-4 col-sm-6 col-xs-12">
                            <p style={{ color: "black" }}> <img src={nameProfileActive} className="active" alt="" /> &nbsp;&nbsp;&nbsp;
                                {getNameContent()}
                            </p>
                        </div>
                        <div className="col-md-4 col-sm-6 col-xs-12">
                            <p> <img src={emailActive} className="active" alt="" /> &nbsp;&nbsp;&nbsp;
                                <a href={`mailto:${email}`} style={{ color: "black" }}>{email}</a></p>
                        </div>
                        {getPhoneNumContent()}
                    </div>
                )
            }

        } else if (props.InvoiceCard == true) {
            return (
                <div className="row mt-5" style={{ marginLeft: "20px" }}>
                    <div className="col-auto">
                        <p className="form-label" style={{ float: "left", color: "#707070", fontWeight: 600 }}>Name :</p>
                    </div>
                    <div className="col-6">
                        <p className="form-label" style={{ float: "left", fontSize: "15px" }}>{getNameContent()}</p>
                    </div>
                    <div className="w-100"></div>
                    <div className="col-auto">
                        <p className="form-label" style={{ float: "left", color: "#707070", fontWeight: 600 }}>Email :</p>
                    </div>

                    <div className="col-6">
                        <p className="form-label" style={{ float: "left", fontSize: "15px" }}>{email}</p>
                    </div>
                    <div className="w-100"></div>
                    {/*<div className="col-auto">
                        <p className="form-label" style={{ float: "left", color: "#707070", fontWeight: 600 }}>Phone :</p>
                    </div>

                    <div className="col-6">
                        <p className="form-label" style={{ float: "left", fontSize: "15px" }}>1234567890</p>
            </div>*/}
                </div>)
        }
        else {
            return (
                <div className="contact-detail row">
                    <div className="col-md-4 col-sm-6 col-xs-12">
                        <div className="contact-box ">
                            <img src={nameProfileActive} className="active" alt="" style={{ width: "12%" }} />
                            <img src={nameProfileInactive} className="inactive" alt="" style={{ width: "12%" }} />
                            <p>
                                {getNameContent()}
                            </p>
                        </div>
                    </div>
                    <div className="col-md-4 col-sm-6 col-xs-12">
                        <div className="contact-box">
                            <img src={emailActive} className="active" alt="" style={{ width: "10%" }} />
                            <img src={emailInactive} className="inactive" alt="" style={{ width: "10%" }} />
                            <p>
                                {email}
                            </p>
                        </div>
                    </div>
                    <div className="col-md-4 col-sm-6 col-xs-12">
                        <div className="contact-box">
                            <img src={phoneActive} className="active" alt="" style={{ width: "10%" }} />
                            <img src={phoneInactive} className="inactive" alt="" style={{ width: "10%" }} />
                            <p>
                                {phoneNum}
                            </p>
                        </div>
                    </div>
                </div>
            )

        }
    }

    return (
        <div>
            {getCardHeader()}
        </div>
    )
}

export default ClientCard;